<template>
    <div>
      <news-list :newsList="newsList" :show-operation="false" :size="30" :news-style="{padding:0}" :listPagination="listPagination" :loading="loading"></news-list>
    </div>
</template>

<script>
  import newsList from '../../../mine/news/module/newsList'
  import newsApi from '@/api/mine/news'
  export default {
    name: 'Index',
    components:{
      newsList
    },
    props:{
      customerId:{
        type:String,
        required:true
      }
    },
    data() {
      return {
        newsList: [],
        loading: false,
        listPagination: {
          onChange: page => {
            this.listPagination.current = page
            this.initList()
          },
          showTotal:(total)=>{
            return `共${total}条`
          },
          hideOnSinglePage:true,
          size:'small',
          current: 1,
          pageSize: 5,
        },

      }
    },
    mounted() {
      this.initList()
    },
    methods: {
      initList() {
        this.loading = true
        newsApi.selectAll({current:this.listPagination.current,size:this.listPagination.pageSize,customerIdStr:this.customerId}).then(res=>{
            if(res.code == 1){
              this.newsList = res.data.records
              this.listPagination.total = res.data.total
            }
        }).finally(()=>{
          this.loading = false
          this.$emit("newSize",this.listPagination.total);
        })
      }
    }
  }
</script>

<style scoped lang="less">

</style>